import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'sa-ui';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from './simulatedQuestionsMessages';

function getErrorMessage(serverMessage = '') {
  switch (serverMessage.trim()) {
    case 'Sorry, all evaluation questions must be approved before proceeding':
      return messages.error_approveAllQuestionsFirst;
    default:
      return messages.error_generic;
  }
}

function formatArrayLanguage(arrayString, intl) {
  if (arrayString.length < 2) return arrayString.join('');
  const and = intl.formatMessage(messages.and);
  const first = arrayString.slice(0, arrayString.length - 1).join(', ');
  const last = arrayString[arrayString.length - 1];
  return `${first} ${and} ${last}`;
}

const ApproveEvaluationResultModal = props => {
  const titleMessage = !props.error
    ? messages.evaluationApproved
    : messages.evaluationApproveFailed;
  const messageMessage = !props.error
    ? messages.evaluationApprovedMessage
    : getErrorMessage(props.error);
  const icon = !props.error ? 'ti-check-box' : 'ti-close';
  const buttonMessage = !props.error ? messages.continue : messages.close;
  const catalogingsLabel = formatArrayLanguage(
    props.evaluation.evaluation.catalogings.map(c => c.name),
    props.intl,
  );

  return (
    <Modal
      show={props.show}
      onClose={props.onClose}
      icon={icon}
      title={<FormattedMessage {...titleMessage} />}
      buttons={[
        {
          label: <FormattedMessage {...buttonMessage} />,
          onClick: props.onClose,
        },
      ]}
    >
      <FormattedMessage
        {...messageMessage}
        values={{ id: props.evaluation.evaluation.id, catalogingsLabel }}
      >
        {txt => <p dangerouslySetInnerHTML={{ __html: txt }} />}
      </FormattedMessage>
    </Modal>
  );
};

ApproveEvaluationResultModal.propTypes = {};

export default injectIntl(ApproveEvaluationResultModal);
